const CALENDAR_VIEW = {
  day: "day",
  month: "month",
  year: "year"
};
export {
  CALENDAR_VIEW
};
